import { Skeleton } from "@particles/index"

import { UserAvatar } from "@molecules"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewCreatedInfo.module.scss"
import { JobPreviewCreatedInfoProps } from "./JobPreviewCreatedInfo.types"

export default function JobPreviewCreatedInfo(props: JobPreviewCreatedInfoProps) {
    const { createdAt, createdBy } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && (!createdAt || !createdBy)) {
        return (
            <div className={styles.base}>
                <Skeleton width={180} height={20} />
            </div>
        )
    }

    if (!createdAt || !createdBy) {
        return null
    }

    return (
        <span className={styles.base}>
            <span className={styles.labelCreatedBy}>Created on {createdAt} by </span>
            <span className={styles.jobCreator}>
                <UserAvatar user={createdBy} size="xs" />
                <span className={styles.jobCreatorName}>{createdBy.full_name}</span>
            </span>
        </span>
    )
}
